import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { DateRange } from 'react-date-range';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import styles from './adgm-date-range-jss';
import './date-range.css';

function ADGMDateRange(props) {
  const { classes } = props;
  const now = useRef(new Date());
  const { onSearch, initialDate = new Date(), endDate = new Date() } = props;
  const [state, setState] = useState({
    startDate: initialDate,
    endDate,
    key: 'selection',
  });

  return (
    <div>
      <DateRange
        dateDisplayFormat='yyyy.MM.dd'
        showDateDisplay={false}
        moveRangeOnFirstSelection
        maxDate={now.current}
        onChange={item => setState(item.selection)}
        ranges={[state]}
        // rangeColors={['#1C999B']}
      />
      <Button variant='contained' onClick={() => onSearch(state)} className={classes.adgmDarkbtn}>
        Search
      </Button>
    </div>
  );
}

ADGMDateRange.propTypes = {
  onSearch: PropTypes.func.isRequired,
  initialDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  classes: PropTypes.object.isRequired,
};

ADGMDateRange.defaultProps = {
  initialDate: new Date(),
  endDate: new Date(),
};

export default withStyles(styles)(ADGMDateRange);
